import {
  SET_TRANSACTIONS,
  GET_TRANSACTIONS,
  REFRESH_TRANSACTIONS,
} from "./types";
const initialState = {
  page: 1,
  limit: 10,
  initialize: true,
  refresh: false,
  isRequesting: false,
  loadMore: true,
  transactions: [],
  pages: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REFRESH_TRANSACTIONS:
      return {
        ...state,
        initialize: true,
        refresh: true,
        isRequesting: false,
        loadMore: true,
        transactions: [],
      };

    case GET_TRANSACTIONS:
      return {
        ...state,
        refresh: false,
        isRequesting: true,
      };

    case SET_TRANSACTIONS:
      const tempPages = [];

      if(payload.lastPage > 0 && state.lastPage != payload.lastPage) {
        for(let i = 1; i <= payload.lastPage; i++) {
          tempPages.push(i);
        }
      }

      return {
        ...state,
        isRequesting: false,
        initialize: false,
        loadMore: payload.loadMore,
        // transactions: [...state.transactions, ...payload.data], // Use this to add more items on the current list when using a load more button or an intersection to load more items.
        transactions: payload.data,
        pages: tempPages.length > 0 ? tempPages : state.pages,
        page:payload.page
      };

    default:
      return state;
  }
};

export default reducer;
